var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('item-block',{attrs:{"item":_vm.item,"active":_vm.active},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var textStyle = ref.textStyle;
var handleChangeValue = ref.handleChangeValue;
return [_c('img',{class:_vm.$style.image,attrs:{"src":_vm.iconImage}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }